import "focus-visible";
import "@/styles/globals.css";

import { useRouter } from "next/router";
// import { route } from 'next/dist/server/router';
import { useEffect } from "react";
import * as ga from "@/lib/analytics";

export default function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    const head = document.head;
    const script = document.createElement("script");
    script.innerHTML = `
      setTimeout(function(){var a=document.createElement("script");
      var b=document.getElementsByTagName("script")[0];
      a.src=document.location.protocol+"//script.crazyegg.com/pages/scripts/0055/6070.js?"+Math.floor(new Date().getTime()/3600000);
      a.async=true;a.type="text/javascript";b.parentNode.insertBefore(a,b)}, 1);
    `;
    head.appendChild(script);
    const handleRouteChange = (url) => {
      ga.pageview(url);
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <Component
      {...pageProps}
      // key={route}
    />
  );
}
